import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ar from 'react-phone-input-2/lang/ar.json';
import SocialMediaInput from './SocialMediaInput';

const Input = ({
  type,
  id,
  value,
  onChange,
  placeholder,
  options,
  acceptFiles,
  countryCode,
  localization,
  required,
  ref,
  errorMessage, // Add this prop
min,
max
}) => {
  console.log('max: ', max,' min:', min)
  const inputClass = required && !value ? 'input-required' : '';

  switch (type) {
    case 'text':
    case 'email':
      return (
        <div className="form-group">
          <label htmlFor={id}>
            {placeholder} {required && <span className="required-asterisk">*</span>}
          </label>
          <input
            type="text"
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClass}
          />
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      );

      case 'url': // Added URL input
      return (
        <div className="form-group">
          <label htmlFor={id}>
            {placeholder} {required && <span className="required-asterisk">*</span>}
          </label>
          <input
            type="url"
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={inputClass}
          />
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      );

    case 'phone':
      return (
        <div className="form-group">
          <label htmlFor={id}>
            {placeholder} {required && <span className="required-asterisk">*</span>}
          </label>
          <PhoneInput
            country={'sa'}
            value={value}
            onChange={onChange}
            localization={localization || ar}
            id={id}
            countryCodeEditable={false}
            inputClass={inputClass}
            preferredCountries={['sa', 'ae', 'qa', 'kw', 'bh', 'om', 'eg', 'ma', 'jo', 'lb', 'iq', 'sy', 'ye', 'dz', 'sd', 'ly', 'tn', 'us', 'gb']}
            placeholder={''} // Leave the placeholder empty to allow default behavior

          />
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      );
      case 'social-media':
        return (
          <SocialMediaInput
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            required={required}
            errorMessage={errorMessage}
            className={inputClass}
          />
        );
  
      case 'date':
        return (
          <div className="form-group">
            <label htmlFor={id}>
              {placeholder}
              {required && <span className="required-asterisk">*</span>}
            </label>
            <input
              type="date"
              id={id}
              value={value}
              onChange={onChange}
              // required={required}
              min={min} // Set minimum selectable date
              max={max} // Set maximum selectable date
            />
          </div>
        );
    case 'select':
      return (
        <div className="form-group">
          <label htmlFor={id}>
            {placeholder} {required && <span className="required-asterisk">*</span>}
          </label>
          <select id={id} value={value} onChange={onChange} className={inputClass}>
            <option value="" disabled>
              {placeholder}
            </option>
            {options?.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      );

    case 'file':
      return (
        <div className="form-group">
          <label htmlFor={id}>
            {placeholder} {required && <span className="required-asterisk">*</span>}
          </label>
          <input
            ref={ref} // Pass the ref to the file input
            type="file"
            id={id}
            accept={acceptFiles}
            onChange={onChange}
            className={inputClass}
          />
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      );
      case 'textarea':
        return (
          <div className="form-group textarea-group">
            <label htmlFor={id}>
          {placeholder} {required && <span className="required-asterisk">*</span>}
        </label>
          <textarea
            id={id}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            // required={required}
            className={inputClass}
          />
           {errorMessage && <div className="error-message">{errorMessage}</div>}
           </div>
        );
  
    default:
      return null;
  }
};

export default Input;
